(function () {
  const { gsap, MorphSVGPlugin } = window;

  const wipe = document.getElementById('gg-spa-wipe');

  if (!gsap) {
    // No GSAP: the choreographed loader can't run. The bloom lives inside the loader,
    // so we can't show it independently — just hide the loader. The page underneath is
    // already orange (data-spa-mode), so this reveals orange, not a broken state.
    const el = document.getElementById('gg-spa-loader');
    if (el) el.style.display = 'none';
    return;
  }

  gsap.registerPlugin(MorphSVGPlugin);

  const loader   = document.getElementById('gg-spa-loader');
  const crown    = document.getElementById('gg-spa-loader-crown');
  const path     = document.getElementById('gg-spa-loader-path');
  const wordmark = document.getElementById('gg-spa-loader-wordmark');
  const fill     = document.getElementById('gg-spa-fill');

  // Always wire up nav-away signal so the destination page can exitFast if needed
  let navTimer;
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript:') || a.target === '_blank') return;
    try { if (new URL(a.href).origin !== location.origin) return; } catch (_) { return; }
    requestAnimationFrame(() => {
      if (e.defaultPrevented) return;
      clearTimeout(navTimer);
      navTimer = setTimeout(() => sessionStorage.setItem('gg-nav-loading', '1'), 300);
    });
  }, true);
  window.addEventListener('pagehide', () => clearTimeout(navTimer));

  // Inline script hid the loader if we didn't arrive from a main page — bail,
  // and drop the bloom element too so it doesn't sit invisibly over the page.
  if (!loader || loader.style.display === 'none') {
    if (wipe) wipe.remove();
    return;
  }
  if (!crown || !path || !wordmark) {
    if (wipe) wipe.remove();
    return;
  }

  const origD = path.getAttribute('d') ?? '';

  // GPU compositing for everything that animates: only transform + opacity are touched,
  // force3D promotes each to its own layer so the main thread never paints during the
  // tween. transformOrigin '50% 50%' keeps the pulse anchored to screen centre.
  gsap.set(crown,    { scale: 0, opacity: 0, xPercent: -50, yPercent: -50, transformOrigin: '50% 50%', force3D: true });
  gsap.set(wordmark, { scale: 0, opacity: 0, xPercent: -50, yPercent: -50, transformOrigin: '50% 50%', force3D: true });
  if (wipe) gsap.set(wipe, { scale: 0, opacity: 1, transformOrigin: '50% 50%', force3D: true });
  if (fill) gsap.set(fill, { opacity: 0, force3D: true });

  const tl = gsap.timeline({ defaults: { force3D: true } });

  tl.to(loader, { opacity: 1, duration: 0.2, ease: 'none' })
    .to(crown,  { scale: 1, opacity: 1, duration: 0.42, ease: 'power3.out' })
    .to(crown,  { rotation: 720, duration: 0.36, ease: 'circ.in' })
    .to(path,   { morphSVG: '#gg-spa-loader-dot', duration: 0.38, ease: 'power1.inOut' }, '<+=0.08')
    .to(crown,  { scale: 1.4, duration: 0.35, ease: 'sine.inOut', yoyo: true, repeat: 1 })
    .to(crown,    { scale: 0, opacity: 0, duration: 0.28, ease: 'power3.in' })
    // The theSPA wordmark pops up here — fire the soft orange pulse on the SAME beat
    // so the colorway washes in behind/with the logo.
    .add('wordmarkPop')
    .to(wordmark, { scale: 1, opacity: 1, duration: 0.45, ease: 'power3.out' }, 'wordmarkPop+=0.1');

  if (wipe) {
    // A LIVING pulse — not one flat ease but a small breath cycle, all on GPU scale/opacity:
    //   1. Anticipation: the bloom swells gently to ~0.32 (slow inhale, sine.out).
    //   2. Release: it surges outward, overshooting to 1.24 with elastic give — the kick
    //      of a heartbeat. back.out's tail makes it feel like it has mass, not a wipe.
    //   3. Settle: eases back to 1.12 (soft exhale, sine.inOut) so the halo breathes to rest.
    // Opacity throbs subtly with the motion so the diffuse edge feels alive, not painted on.
    tl.to(wipe, { scale: 0.32, duration: 0.42, ease: 'sine.out' }, 'wordmarkPop')
      .to(wipe, { scale: 1.24, duration: 0.95, ease: 'back.out(1.6)' }, '>-0.05')
      .to(wipe, { scale: 1.12, duration: 0.7,  ease: 'sine.inOut' },   '>-0.25')
      // breath on opacity: dip slightly as it surges, brim back as it settles
      .fromTo(wipe, { opacity: 0.82 }, { opacity: 1, duration: 1.1, ease: 'sine.inOut' }, 'wordmarkPop+=0.3');

    // The flat solid-orange sheet fades in UNDERNEATH the bloom, locking the screen to
    // fully solid --gg-orange (no transparency, no page peek-through). Opacity only.
    // Trails the pulse's release so you read the living soft edge first, then it firms up.
    if (fill) {
      tl.to(fill, { opacity: 1, duration: 0.9, ease: 'power2.inOut' }, 'wordmarkPop+=0.6');
    }
  }

  // Hold on solid orange + wordmark — page behind is already loaded, so keep it brief.
  tl.add('hold', '>')
    .to({}, { duration: 0.35 }, 'hold')
    // Logo fades, then the WHOLE loader (orange bloom + cream backdrop + wordmark) fades
    // together as one layer, revealing the already-orange page underneath — seamless,
    // no cream flash. We never fade the orange separately (that would expose the cream).
    .add('exit', '>')
    .to(wordmark, { opacity: 0, scale: 0.9, duration: 0.4, ease: 'power2.in' }, 'exit')
    .to(loader,   { opacity: 0, duration: 0.5, ease: 'power1.inOut' }, 'exit+=0.15')
    .set(loader,  { display: 'none' })
    .set(path,    { morphSVG: origD })
    // Release the promoted GPU layers / will-change once the loader is gone so they
    // don't hold compositor memory for the rest of the session.
    .set([wipe, fill, crown, wordmark].filter(Boolean), { clearProps: 'willChange,transform' });
})();
